import createReducer from '../../redux/createReducer'
import { SET_BALANCE, SET_AUTOPLAY, STOP_AUTOPLAY, SET_SPINS,
  DISABLE_AUTOPLAY, RUN_AUTOPLAY, AUTOPLAY_DONE } from './constants'

// The initial state of the App
const initialState = {
  spinsLeft: 0,
  autoplayBalance: 0,
  lossLimit: 0,
  winLimit: 0,
  singleWinLimit: 0,
  disabled: false
}

export default function autoPlay(state = initialState, action) {
  switch (action.type) {
    case STOP_AUTOPLAY: {
      return createReducer(state, { spinsLeft: 0 })
    }
    case SET_SPINS: {
      const { spins } = action
      return createReducer(state, { spinsLeft: spins })
    }
    case SET_AUTOPLAY: {
      const { spins, lossLimit, winLimit, singleWinLimit } = action.autoPlay
      return createReducer(state, {
        spinsLeft: Number(spins),
        lossLimit: Number(lossLimit),
        winLimit: Number(winLimit),
        singleWinLimit: Number(singleWinLimit)
      })
    }
    case SET_BALANCE: {
      const { balance } = action
      return createReducer(state, { autoplayBalance: balance })
    }
    case DISABLE_AUTOPLAY: {
      const { disabled } = action
      return createReducer(state, { disabled })
    }
    case RUN_AUTOPLAY: {
      return createReducer(state, { autoPlaying: true })
    }
    case AUTOPLAY_DONE: {
      return createReducer(state, { autoPlaying: false })
    }
    default:
      return state
  }
}

export const name = 'autoPlay'
